$(document).ready(function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $("#productImagesDesktop").remove();
  }
  if (window.matchMedia("(min-width: 768px)").matches) {
    $(".custom_mobile_images").remove();
  }
  // if (window.matchMedia("(min-width: 767px)").matches) {
  //   $(".change-main-image").hover(function (e) {
  //     e.preventDefault();
  //     let $this = $(this);
  //     var $thisProduct = $this.closest(".grid-product");
  //     $thisProduct.find(".change-main-image").removeClass("active");
  //     $this.addClass("active");
  //     var mainImage = $thisProduct.find(".grid__image-ratio-main");
  //     var mainImage_slider = $thisProduct.find(".slick-current.slick-active");
  
  //     if ($($thisProduct.find(".zodiac_product-variants")).length) {
  //       var currentSwatchName = $this.attr("data-value");
  //       var current_variant_name = $thisProduct.find(".Selected_variant.variant__button-label").parent().attr('data-value');
  //        if (current_variant_name == null){
  //       current_variant_name = $thisProduct.find('.zodiac-products-inner.Selected_variant:first').find('.zodiac-icon-text').text();
  //     }
  //       var fullSelectedVariant =
  //         currentSwatchName + " / " + current_variant_name;
  
  //       console.log(fullSelectedVariant);
  
  //       var VariantImage = $thisProduct
  //         .find(
  //           ".product_all_variants option:contains(" + fullSelectedVariant + ")"
  //         )
  //         .attr("variant-image");
  //       console.log(VariantImage);
  //       mainImage.attr("data-bgset", VariantImage);
  //       mainImage.css("background-image", "url(" + VariantImage + ")");
  //       mainImage_slider.attr("data-bgset", VariantImage);
  //       mainImage_slider.css("background-image", "url(" + VariantImage + ")");
  //     } else {
  //       mainImage.attr("data-bgset", $this.attr("data-variant-image"));
  //       mainImage.css(
  //       "background-image",
  //       "url(" + $this.attr("data-variant-image") + ")"
  //     );
  //       mainImage_slider.attr("data-bgset", $this.attr("data-variant-image"));
  //       mainImage_slider.css(
  //         "background-image",
  //         "url(" + $this.attr("data-variant-image") + ")"
  //       );
  //     }
  //     mainImage.removeClass("hide");
  //     mainImage_slider.removeClass("hide");
  //     $thisProduct.find("video").addClass("hide");
  //   });
  // }

$(document).on("click", ".change-main-image", function (e) {
    e.preventDefault();

    const $this = $(this);
    const $thisProduct = $this.closest(".grid-product");

    $thisProduct.find(".change-main-image").removeClass("active");
    $this.addClass("active");

    const mainImage = $thisProduct.find(".grid__image-ratio-main");
    const mainImageSlider = $thisProduct.find(".slick-current.slick-active");

    let variantImage = $this.attr("data-variant-image");
    let variantPrice = $this.attr("data-variant-price");
    let compareAtPrice = $this.attr("data-variant-compare_price");
    let materialName = $this.attr("data-variant-title");

    if ($thisProduct.find(".zodiac_product-variants").length) {
        const currentSwatchName = $this.attr("data-value");
        let currentVariantName = $thisProduct.find(".Selected_variant.variant__button-label").parent().attr("data-value");

        if (!currentVariantName) {
            currentVariantName = $thisProduct.find('.zodiac-products-inner.Selected_variant:first').find('.zodiac-icon-text').text();
        }

        const fullSelectedVariant = `${currentSwatchName} / ${currentVariantName}`;

        variantImage = $thisProduct
            .find(`.product_all_variants option:contains("${fullSelectedVariant}")`)
            .attr("variant-image");
    }

    if (variantImage) {
        mainImage.attr("data-bgset", variantImage).css("background-image", `url(${variantImage})`);
        mainImageSlider.attr("data-bgset", variantImage).css("background-image", `url(${variantImage})`);
    }

    // Update variant price
    if (variantPrice) {
        variantPrice = variantPrice.replace(/<span[^>]*>|<\/span>/g, ''); // Remove any <span> tags
        $thisProduct.find(".variant-price").text(variantPrice);
    }

    // Update compare at price
    if (compareAtPrice) {
        compareAtPrice = compareAtPrice.replace(/<span[^>]*>|<\/span>/g, ''); // Remove any <span> tags
        $thisProduct.find(".compare-at-price").text(compareAtPrice);
    }

   // Update materialName
  if (materialName) {
        $thisProduct.find(".material_name-js").text(materialName);
    }

    mainImage.removeClass("hide");
    mainImageSlider.removeClass("hide");
    $thisProduct.find("video").addClass("hide");
});



  $(".variant__button-label.letter_pendent").click(function () {
    event.preventDefault();
    let $this = $(this);
    var $thisProduct = $this.closest(".grid-product");
    $(".letter_pendent").removeClass("Selected_variant");
    $this.addClass("Selected_variant");
    var mainImage = $this
      .parents(".grid__item")
      .first()
      .find(".grid__image-ratio-main");
      var currentSwatchName = $thisProduct.find('.change-main-image.active').attr("data-value");
      var current_variant_name = $this.parent().attr('data-value');
     
      var fullSelectedVariant =
        currentSwatchName + " / " + current_variant_name;

      console.log(fullSelectedVariant);

      var VariantImage = $thisProduct
        .find(
          ".product_all_variants option:contains(" + fullSelectedVariant + ")"
        )
        .attr("variant-image");
      console.log(VariantImage);
      mainImage.attr("data-bgset", VariantImage);
      mainImage.css("background-image", "url(" + VariantImage + ")");
  });
  $(".arrow-container").click(function (e) {
    e.preventDefault();
  });

  $(".zodiac-products-inner").click(function (e) {
    event.preventDefault();
    let $this = $(this);
    var $thisProduct = $this.closest(".grid-product");
    $(".zodiac-products-inner").removeClass("Selected_variant");
    $this.addClass("Selected_variant");
    var mainImage = $this
      .parents(".grid__item")
      .first()
      .find(".grid__image-ratio-main");
      var currentSwatchName = $thisProduct.find('.change-main-image.active').attr("data-value");
      var current_variant_name = $this.find('.zodiac-icon-text').text();
      var fullSelectedVariant =
        currentSwatchName + " / " + current_variant_name;

      console.log(fullSelectedVariant);

      var VariantImage = $thisProduct
        .find(
          ".product_all_variants option:contains(" + fullSelectedVariant + ")"
        )
        .attr("variant-image");
      console.log(VariantImage);
      mainImage.attr("data-bgset", VariantImage);
      mainImage.css("background-image", "url(" + VariantImage + ")");
    mainImage.removeClass("hide");
      $thisProduct.find("video").addClass("hide");
  });

  document.addEventListener('variant:change', function(evt) {
    
    console.log(evt.detail.variant);
    if ($('.variant-without-image.zodiac_product-variants').length > 0) {

    var customArray = $(".variant-with-image").map(function () {
        return $(this).attr("data-value");
    }).get();

    var goldText = customArray.find(value => value.includes("Gold")) || '';
    var silverText = customArray.find(value => value.includes("Silver")) || '';
    var nichirinText = customArray.find(value => value.includes("Nichirin")) || '';

    var currentOptions = evt.detail.variant.option3 
        ? evt.detail.variant.option2 + " / " + evt.detail.variant.option3
        : evt.detail.variant.option2;

    var fullSelectedVariantGold = `${goldText} / ${currentOptions}`;
    var fullSelectedVariantSilver = `${silverText} / ${currentOptions}`;
    var fullSelectedVariantNichirin = `${nichirinText} / ${currentOptions}`;

    console.log(fullSelectedVariantGold);
    console.log(fullSelectedVariantSilver);
    console.log(fullSelectedVariantNichirin);

    var goldVariantImage = $(".product-single__variants option:contains(" + fullSelectedVariantGold + ")")
        .attr("variant-image");
    var silverVariantImage = $(".product-single__variants option:contains(" + fullSelectedVariantSilver + ")")
        .attr("variant-image");
    var nichirinVariantImage = $(".product-single__variants option:contains(" + fullSelectedVariantNichirin + ")")
        .attr("variant-image");

    console.log(goldVariantImage);
    console.log(silverVariantImage);
    console.log(nichirinVariantImage);

    $(".change_circle-gold-image").css("background-image", "url(" + goldVariantImage + ")");
    $(".change_circle-silver-image").css("background-image", "url(" + silverVariantImage + ")");
    $(".change_circle-nichirin-image").css("background-image", "url(" + nichirinVariantImage + ")");
    $(".sticky-gold-img-change").attr("src", goldVariantImage);
    $(".sticky-silver-img-change").attr("src", silverVariantImage);
    $(".sticky-nichirin-img-change").attr("src", nichirinVariantImage);

    var currentLabel = $(".variant__label-current").text();
    if (currentLabel.includes("Gold")) {
        $("#js-image-change").attr("src", goldVariantImage);
    } else if (currentLabel.includes("Silver")) {
        $("#js-image-change").attr("src", silverVariantImage);
    } else if (currentLabel.includes("Nichirin")) {
        $("#js-image-change").attr("src", nichirinVariantImage);
    }
}


     // Split the variant title by "/" and trim each value
    const evtVariant = evt.detail.variant; 
    const variant = evt.detail.variant.title; 
   const variantValues = variant.split('/').map(value => value.trim());

    const color = variantValues[0] || ''; 
    const size = variantValues[1] || '';  
    const stone = variantValues[2] || ''; 


// Function to handle the active class toggling
function toggleActiveClass(selector, variantValues) {
    $(selector).each(function() {
        // Check if the attribute 'variant-name' exists before accessing it
        let variantName = $(this).attr('variant-name');
        
        if (variantName) {
            variantName = variantName.trim();  // Only run trim if attribute is present
            if (variantValues.includes(variantName)) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        }
    });
}

// Check if the '#product-atc-material' element exists
if ($('#product-atc-material').length) {
    $('#product-atc-material').removeClass('active');
    toggleActiveClass('#product-atc-material .variant__item', [color, size, stone]);
}

// Check if there are no '.variant__item' inside '#product-atc-material', then check '#product-atc-bar--mobile'
if ($('#product-atc-material').find('.variant__item').length == 0 && $('#product-atc-bar--mobile').length) {
    toggleActiveClass('#product-atc-bar--mobile .variant__item', [color, size, stone]);
}

// Check for '.select-stone__item' if it exists
if ($('.select-stone__item').length) {
    toggleActiveClass('.select-stone__item', [color, size, stone]);
}

// Check for '.select-size__item' if it exists
if ($('.select-size__item').length) {
    toggleActiveClass('.select-size__item', [color, size, stone]);
}

    var restockDateElement = $('#restock-date');
    
    if (restockDateElement.length > 0) {
        console.log('fff');
        
        if (typeof evtVariant !== 'undefined' && evtVariant.available) {
            console.log('fff2');
            restockDateElement.css('display', 'none');
        } else {
            console.log('fff23');
            restockDateElement.css('display', 'block');
        }
    }



    
   });

  // $(document).on(
  //   "click",
  //   ".variant-without-image.zodiac_product-variants",
  //   function () {
  //     var customArray = [];
  //     $(".variant-with-image").each(function () {
  //       customArray.push($(this).attr("data-value"));
  //     });
  //     var customGold = customArray[0];
  //     if (typeof customGold !== "undefined") {
  //       if (customGold.indexOf("Gold") != -1) {
  //         var goldText = customArray[0];
  //       } else {
  //         var sliverText = customArray[0];
  //       }
  //     }
  //     var customSilver = customArray[1];
  //     if (typeof customSilver !== "undefined") {
  //       if (customSilver.indexOf("Gold") != -1) {
  //         var goldText = customArray[1];
  //       } else {
  //         var sliverText = customArray[1];
  //       }
  //     }

  //     var current_variant_name = $(this).attr("data-value");
  //     var totalOptionSize = $(this)
  //       .closest(".product-block")
  //       .attr("option-size");
  //     console.log("totalOptionSize " + totalOptionSize);
  //     if (totalOptionSize == 3) {
  //       console.log("Its-true");
  //       var thirdOptionName = $('input[name="Size"]:checked').val();
  //       if (thirdOptionName == null) {
  //         thirdOptionName = $('input[name="Design"]:checked').val();
  //       }
  //       console.log("thirdOptionName " + thirdOptionName);
  //       var fullSelectedVariantGold =
  //         goldText + " / " + current_variant_name + " / " + thirdOptionName;
  //       var fullSelectedVariantSilver =
  //         sliverText + " / " + current_variant_name + " / " + thirdOptionName;
  //     } else {
  //       var fullSelectedVariantGold = goldText + " / " + current_variant_name;
  //       var fullSelectedVariantSilver =
  //         sliverText + " / " + current_variant_name;
  //     }

  //     console.log(fullSelectedVariantGold);
  //     console.log(fullSelectedVariantSilver);

  //     var goldVariantImage = $(
  //       ".product-single__variants option:contains(" +
  //         fullSelectedVariantGold +
  //         ")"
  //     ).attr("variant-image");
  //     var goldtextt = $(
  //       ".product-single__variants option:contains(" +
  //         fullSelectedVariantGold +
  //         ")"
  //     ).text();
  //     console.log(goldVariantImage);

      
  //     var silverVariantImage = $(
  //       ".product-single__variants option:contains(" +
  //         fullSelectedVariantSilver +
  //         ")"
  //     ).attr("variant-image");

  //     var silverColorSwatch = $(".change_circle-silver-image");
  //     var goldColorSwatch = $(".change_circle-gold-image");
  //     silverColorSwatch.css(
  //       "background-image",
  //       "url(" + silverVariantImage + ")"
  //     );
  //     goldColorSwatch.css("background-image", "url(" + goldVariantImage + ")");
  //     $(".sticky-gold-img-change").attr("src", goldVariantImage);
  //     $(".sticky-silver-img-change").attr("src", silverVariantImage);
  //     var text = $(".variant__label-current").text();
  //     var term = "Gold";
  //     if (text.indexOf(term) != -1)
  //       $("#js-image-change").attr("src", goldVariantImage);
  //     else $("#js-image-change").attr("src", silverVariantImage);
  //   }
  // );
  
  // For Material Tab update
  if ($('input[name="Stone"]')) {
  var selectedStone = $('input[name="Stone"]:checked')
    .parent()
    .attr("data-value");
  }
   else if ($('input[name="Style"]')) {
      var selectedStone = $('input[name="Style"]:checked')
    .parent()
    .attr("data-value");
    }
  else if ($('input[name="Color"]')) {
      var selectedStone = $('input[name="Color"]:checked')
    .parent()
    .attr("data-value");
    }

  console.log('selectedStone' + selectedStone);

  var selectedMaterial = $('input[name="Material"]:checked')
    .parent()
    .attr("data-value");
  if (typeof selectedMaterial !== "undefined") {
    $(".material--content-wrapper").hide();
    $(
      '.material--content-wrapper[data-type="' + selectedMaterial + '"]'
    ).show();

    
    
  }
  if (typeof selectedStone !== "undefined") {
    $(".stone--content-wrapper").hide();
    $('.stone--content-wrapper[data-type="' + selectedStone + '"]').show();
  }

  $(".product-block.product-block--tab:first button.collapsible-trigger-btn").click();
  
  $(".Material-tab_js").click(function () {
    let $this = $(this);
    var materialType = $this.attr("data-value");
    $(".material--content-wrapper").hide();
    $('.material--content-wrapper[data-type="' + materialType + '"]').show();

    setTimeout(function () {
      let $this2;
      if ($('input[name="Stone"]')) { $this2 = $('input[name="Stone"]:checked').parent(); } else if ($('input[name="Style"]')) { $this2 = $('input[name="Style"]:checked').parent(); }
      if ($this2.length > 0) {
        var materialType = $this2.attr("data-value");
        $(".variant__label-info-stone").find("span").text(materialType);
        $(".stone--content-wrapper").hide();
        $('.stone--content-wrapper[data-type="' + materialType + '"]').show();
      }
    }, 300);
  });

  $(".stone-tab_js").click(function () {
    let $this = $(this);
    var materialType = $this.attr("data-value");
    $(".variant__label-info-stone").find("span").text(materialType);
    $(".stone--content-wrapper").hide();
    $('.stone--content-wrapper[data-type="' + materialType + '"]').show();
  });


  // Custom FAQ page

  $(".Faq-filter-button").click(function (e) {
    e.preventDefault();
    let $this = $(this);
    var materialType = $this.attr("id");
    $("html, body").animate(
      {
        scrollTop:
          $('.custom-faq-main[data-category="' + materialType + '"]').offset()
            .top - 85,
      },
      500
    );
  });
});

// Cart Drawer Upsells
$(document).ready(function () {

    function isCart() {
  return document.URL.includes("/cart");
}
  
  
  $(document).on("click", ".custom-upsell-add", function (e) {
    e.preventDefault();
     $(this).addClass('hide');
    $(this)
      .find("button")
      .append("<div class='loader' style='margin-left: 5px;'></div>");
    let upsellId = $(this).attr("current_variant");
    if (upsellId) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: upsellId,
        },
        dataType: "json",
        success: function (data) {
          if (isCart()) {
              location.reload();
            } else {
                document.dispatchEvent(new CustomEvent("cart:build")); // Refresh cart drawer
              }
          $(".cart-upsell-product-main[data-id=" + upsellId + "]").addClass(
            "hide"
          );
        },
      });
    }
    $(".cartpopup").fadeOut();
  });


  $(document).on("change", ".cart-gift-bag-upsell-checkbox", function () {
    let $checkbox = $(this);
    let upsellId = $checkbox.attr("data-id");

    if ($checkbox.is(":checked")) {
        // Add product to cart
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
                quantity: 1,
                id: upsellId,
            },
            dataType: "json",
            success: function () {
              if (isCart()) {
              location.reload();
            } else {
                document.dispatchEvent(new CustomEvent("cart:build")); // Refresh cart drawer
              }
            },
            error: function () {
                $checkbox.prop("checked", false); // Uncheck if the request fails
            }
        });
    } else {
        // Remove product from cart
        $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json",
            success: function (cart) {
                let lineItemId = null;
                for (let item of cart.items) {
                    if (item.variant_id == upsellId) {
                        lineItemId = item.id; // Get the line item key
                        break;
                    }
                }
                if (lineItemId) {
                    $.ajax({
                        type: "POST",
                        url: "/cart/change.js",
                        data: {
                            id: lineItemId,
                            quantity: 0,
                        },
                        dataType: "json",
                        success: function () {
                            if (isCart()) {
              location.reload();
            } else {
                document.dispatchEvent(new CustomEvent("cart:build")); // Refresh cart drawer
              }
                        }
                    });
                }
            }
        });
    }
});

  Shopify.getCart(function (cart) {
    if (cart.status === 422) {
      this.error(data);
    } else {
      let upsell_1ID = $("#upsell_1_id").attr("product_id");
      let upsell_2ID = $("#upsell_2_id").attr("product_id");
      let upsell_3ID = $("#upsell_3_id").attr("product_id");
      let mainCartItems = cart.items;
      let found_package_in_cart = false;
      let line_item_id = null;
      for (var i = 0; i < mainCartItems.length; i++) {
        line_item_id = mainCartItems[i].product_id;
        if (
          line_item_id == upsell_1ID ||
          line_item_id == upsell_2ID ||
          line_item_id == upsell_3ID
        ) {
          $(".cart-upsell-product-main[product_id=" + line_item_id + "]").addClass(
            "hide"
          );
        }
      }
    }
  });
  document.addEventListener("cart:updated", function (evt) {
    if (document.URL.includes("/cart")) {
              location.reload();
    }
    console.log('working');
     let upsell_1ID = $("#upsell_1_id").attr("product_id");
      let upsell_2ID = $("#upsell_2_id").attr("product_id");
      let upsell_3ID = $("#upsell_3_id").attr("product_id");
    let mainCartItems = evt.detail.cart.items;
    let found_package_in_cart = false;
    let line_item_id = null;
    for (var i = 0; i < mainCartItems.length; i++) {
      line_item_id = mainCartItems[i].product_id;
      if (
        line_item_id == upsell_1ID ||
        line_item_id == upsell_2ID ||
        line_item_id == upsell_3ID
      ) {
        $(".cart-upsell-product-main[product_id=" + line_item_id + "]").addClass(
          "hide"
        );
      }
      else
      {
        $(".cart-upsell-product-main[product_id=" + line_item_id + "]").removeClass(
          "hide"
        );
      }
    }
    
      let checkboxProductId = $(".cart-gift-bag-upsell-checkbox").attr("data-id");
    
        let productInCart = mainCartItems.some(item => item.id.toString() === checkboxProductId);

        if (productInCart) {
            checkbox.setAttribute("checked", "checked");
        } else {
          $(".cart-gift-bag-upsell-checkbox").prop("checked" , false);
        }

  });

  $(document).on("click", "#add_product1 .cstm-btn", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("#product1").addClass("active");
    $("#product1").fadeIn();
  });
  $(document).on("click", "#add_product2 .cstm-btn", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("#product2").addClass("active");
    $("#product2").fadeIn();
  });
  $(document).on("click", "#add_product3 .cstm-btn", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("#product3").addClass("active");
    $("#product3").fadeIn();
  });

  $("select.CustomProductSelect").on("change", function () {
    var variantPrice = $(this).find("option:selected").attr("price");
    var element = $(variantPrice); //convert string to JQuery element
    element.find("span").each(function (index) {
      var text = $(this).text(); //get span content
      $(this).replaceWith(text); //replace all span with just content
    });
    variantPrice = element.html(); //get back new string
    // alert(variantPrice);
    $(this)
      .parent()
      .siblings(".custom-upsell-add")
      .attr("current_variant", this.value);
    $(this)
      .parent()
      .siblings(".custom-upsell-options-header")
      .find(".custom-upsell-options-variant")
      .text($(this).find("option:selected").text());
    $(this)
      .parent()
      .siblings(".custom-upsell-options-header")
      .find(".custom-upsell-options-prices .price")
      .text(variantPrice);
      var main_product_id = $(this).closest('.js_cartpopup').attr('product_id');
      $(".cart-upsell-product-main[product_id=" + main_product_id + "]").attr('data-id', this.value)
      
  });
  $(document).on("click", ".cartpopup", function (e) {
    e.stopPropagation();
  });

  $(document).on("click", function (event) {
    $(".cartpopup").removeClass("active");
    $(".cartpopup").fadeOut();
  });
   $(document).on("click", ".close-button.topright", function (event) {
    $(".cartpopup").removeClass("active");
    $(".cartpopup").fadeOut();
  });

  if ($(".carousel-featured-slider").length) {
    $(".carousel-featured-slider").slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 3,
      swipeToSlide: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 1324,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  }
  if (window.matchMedia("(max-width: 767px)").matches) {
    if ($(".thumbnail-slick-carousel").length) {
      $(".thumbnail-slick-carousel").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        swipeToSlide: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 0,
              slidesToScroll: 3,
              infinite: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 5,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 4,
            },
          },
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
      });
    }
  }
  if (window.matchMedia("(min-width: 767px)").matches) {
    if ($(".zodiac-slider").length) {
      $(".zodiac-slider").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 6,
        swipeToSlide: true,
        arrows: true,
      });
    }
    if ($(".letter-pendant-slider").length) {
      $(".letter-pendant-slider").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 6,
        swipeToSlide: true,
        arrows: true,
      });
    }
  }
  // if ($(".product-image-carousel").length) {
  //   $(".product-image-carousel").slick({
  //     dots: false,
  //     infinite: false,
  //     speed: 300,
  //     slidesToShow: 3.3,
  //     swipeToSlide: true,
  //     arrows: true,
  //     responsive: [
  //       {
  //         breakpoint: 1024,
  //         settings: {
  //           slidesToShow: 3,
  //           slidesToScroll: 3,
  //           infinite: false,
  //         },
  //       },
  //       {
  //         breakpoint: 600,
  //         settings: {
  //           slidesToShow: 2,
  //           slidesToScroll: 1,
  //         },
  //       },
  //       {
  //         breakpoint: 480,
  //         settings: {
  //           slidesToShow: 1.5,
  //           slidesToScroll: 1,
  //         },
  //       },
  //       // You can unslick at a given breakpoint now by adding:
  //       // settings: "unslick"
  //       // instead of a settings object
  //     ],
  //   });
  // }
  if ($(".products-images-slider").length) {
    $(".products-images-slider").slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      swipeToSlide: true,
      arrows: false,
    });
  }
});

$(document).on("click", "#CartDrawer", function (e) {
  e.stopPropagation();
});

$(document).on("click", function (event) {
  $("#CartDrawer").addClass("is-transitioning");
  $("#CartDrawer").removeClass("is-transitioning drawer--is-open");
});

$(document).ready(function () {
  function focusAndOpenKeyboard(el, timeout) {
    if (!timeout) {
      timeout = 100;
    }
    if (el) {
      // console.log('functionCallsed2');
      // Align temp input element approximately where the input element is
      // so the cursor doesn't jump around
      var __tempEl__ = document.createElement("input");
      __tempEl__.style.position = "absolute";
      __tempEl__.style.top = el.offsetTop + 7 + "px";
      __tempEl__.style.left = el.offsetLeft + "px";
      __tempEl__.style.height = 0;
      __tempEl__.style.opacity = 0;
      // Put this temp element as a child of the page <body> and focus on it
      document.body.appendChild(__tempEl__);
      __tempEl__.focus();

      // The keyboard is open. Now do a delayed focus on the target element
      setTimeout(function () {
        el.focus();
        el.click();
        // Remove the temp element
        document.body.removeChild(__tempEl__);
      }, timeout);
    }
  }
  $(".js-search-header img.newIcons").click(function (e) {
    e.preventDefault();
    // console.log('functionCallsed');
    var myElement = $(".site-header__search-input");
    var modalFadeInDuration = 300;
    focusAndOpenKeyboard(myElement, modalFadeInDuration); // or without the second argument
  });

  // Account Popup

  $(document).on("click", ".account-popup-target", function (e) {
    e.preventDefault();
    $(".js-drawer-close").click();
    $("#modal-close-default").delay(100).show();
    $("html").addClass("hydrated js-drawer-open");
  });
  $(document).on("click", ".custom-account-close", function (e) {
    e.preventDefault();
    $("#modal-close-default").delay(100).hide();
    $("html").removeClass("hydrated js-drawer-open");
  });
  $(document).on("click", "#customRecoverPassword", function (e) {
    e.preventDefault();
    $("#CustomerLoginForm, .login-acount-heading.login").addClass("hide");
    $("#RecoverPasswordForm, .login-acount-heading.reset").removeClass("hide");
  });

  $(document).on("click", "#customHideRecoverPasswordLink", function (e) {
    e.preventDefault();
    $("#CustomerLoginForm, .login-acount-heading.login").removeClass("hide");
    $("#RecoverPasswordForm, .login-acount-heading.reset").addClass("hide");
  });

  // End Account Popup

  // sticky add to cart button

  var sticky_variant_namee = $(
    ".variant-input-wrap .variant-without-image--size input:checked"
  ).val();
  if (!sticky_variant_namee) {
    sticky_variant_namee = $(
      ".variant-input-wrap .variant-without-image--new input:checked"
    ).val();
  }
  var sticky_variant_stone = $(
    ".variant-input-wrap .stone-sticky-handle-js input:checked"
  ).val();
  if ($(".product-atc-bar__size-number").length > 0) {
    $(".product-atc-bar__size-number").text(sticky_variant_namee);
  }
  if ($(".product-atc-bar__stone-number").length > 0) {
    $(".product-atc-bar__stone-number").text(sticky_variant_stone);
  }

  $(document).on("click", ".variant__swatch-wrap", function () {
    $(".product-atc-bar__popup--material").removeClass("activated");
    $(".js-product-bar-buy-select-size").removeClass("activated");
    $('.variant__swatch-wrap').removeClass('active');
    $(this).addClass('active');
    //     console.log($("select.product-single__variants").find(":selected").text();)
    var sticky_variant_id = $(this).attr("variant-id");
    var sticky_variant_name = $(this).attr("variant-name");
    var sticky_variant_image = $(this).find("img").attr("src");
    console.log(sticky_variant_image);
    $("#js-image-change").attr("src", sticky_variant_image);
    $(".variant__label-current").text(sticky_variant_name);
    $(".variant__label-info span").text(sticky_variant_name);
    var mainProductVariant = $(
      '.variant-input-wrap .variant-with-image[variant-id="' +
        sticky_variant_id +
        '"]'
    );
    //     console.log(mainProductVariant);
    //     mainProductVariant.find('input').prop('checked', true);
    mainProductVariant.find("label").click();
  });

  $(document).on("click", ".select-size__item", function () {
    $(".product-atc-bar__popup--material").removeClass("activated");
    var sticky_variant_id = $(this).attr("variant-id");
    var sticky_variant_name = $(this).attr("variant-name");
    $(".product-atc-bar__size-number").text(sticky_variant_name);
    var mainProductVariant = $(
      '.variant-input-wrap .variant-without-image--size[variant-id="' +
        sticky_variant_id +
        '"]'
    );
    if (mainProductVariant.length == 0) {
      mainProductVariant = $(
        '.variant-input-wrap .variant-without-image--new[variant-id="' +
          sticky_variant_id +
          '"]'
      );
    }
    console.log(mainProductVariant);
    // //     mainProductVariant.find('input').prop('checked', true);

    mainProductVariant.find("label").click();
  });

  $(document).on("click", ".select-stone__item", function () {
    $('.select-stone__item').removeClass("active");
    $(this).addClass("active");
    $(".product-atc-bar__popup--material").removeClass("activated");
    var sticky_variant_id = $(this).attr("variant-id");
    var sticky_variant_name = $(this).attr("variant-name");
    $(".product-atc-bar__stone-number").text(sticky_variant_name);
    var mainProductVariant = $(
      '.variant-input-wrap .stone-sticky-handle-js[variant-id="' +
        sticky_variant_id +
        '"]'
    );
    //     console.log(mainProductVariant);
    // //     mainProductVariant.find('input').prop('checked', true);

    mainProductVariant.find("label").click();
  });

  $(document).on("click", ".variant-input.variant-with-image", function () {
    //     console.log($("select.product-single__variants").find(":selected").text();)
    var sticky_variant_id = $(this).attr("variant-id");
    var sticky_variant_name = $(this).attr("variant-name");
    // var sticky_variant_image = $('.stone-sticky-handle-js input:checked').closest('.stone-sticky-handle-js').attr('variant-image');
    //   if (!sticky_variant_image) {
    //      sticky_variant_image = $(this).attr('variant-image');
    //   }var bg_img = $('body').css('background-image').replace(/^url\(['"](.+)['"]\)/, '$1');

    var sticky_variant_image = $(this)
      .find("label")
      .css("background-image")
      .replace(/^url\(['"](.+)['"]\)/, "$1");
    console.log(sticky_variant_image);
    $("#js-image-change").attr("src", sticky_variant_image);
    $(".variant__label-current").text(sticky_variant_name);

    setTimeout(function () {
      let variantWithOutImage = $(
        ".variant-without-image--new input:checked"
      ).val();
      if (!variantWithOutImage) {
        variantWithOutImage = $(
          ".variant-without-image--size input:checked"
        ).val();
      }
      console.log(variantWithOutImage);
      $(".product-atc-bar__size-number").text(variantWithOutImage);
    }, 400);
  });

  $(document).on(
    "click",
    ".variant-input.variant-without-image--size",
    function () {
      //     console.log($("select.product-single__variants").find(":selected").text();)
      var sticky_variant_id = $(this).attr("variant-id");
      var sticky_variant_name = $(this).attr("variant-name");
      $(".product-atc-bar__size-number").text(sticky_variant_name);
      $(".select-size__item").each(function () {
        if ($(this).attr("variant-name") === sticky_variant_name) {
            $(".select-size__item").removeClass("active"); 
            $(this).addClass("active");
        }
    });
    }
  );

  $(document).on(
    "click",
    ".variant-input.variant-without-image--new",
    function () {
      //     console.log($("select.product-single__variants").find(":selected").text();)
      var sticky_variant_id = $(this).attr("variant-id");
      var sticky_variant_name = $(this).attr("variant-name");
      $(".product-atc-bar__size-number").text(sticky_variant_name);
    }
  );

$(document).on("click", ".variant-input.stone-sticky-handle-js", function () {
    // Get the variant ID and name from the clicked element
    var sticky_variant_id = $(this).attr("variant-id");
    var sticky_variant_name = $(this).attr("variant-name");

    $(".product-atc-bar__stone-number").text(sticky_variant_name);

    $(".select-stone__item").each(function () {
        if ($(this).attr("variant-name") === sticky_variant_name) {
            $(".select-stone__item").removeClass("active"); 
            $(this).addClass("active");
        }
    });

    setTimeout(function () {
        let variantWithOutImage = $(
            ".variant-without-image--new input:checked"
        ).val();
        if (!variantWithOutImage) {
            variantWithOutImage = $(
                ".variant-without-image--size input:checked"
            ).val();
        }
        console.log(variantWithOutImage);
        $(".product-atc-bar__size-number").text(variantWithOutImage);
    }, 400);
});


  

  $(".addtoCartbutton.btn").on("DOMSubtreeModified", function () {
    if ($(this).is(":disabled")) {
      $('.product-block-custom-html').addClass('custom_sold-out-margin');
      $("#sicky-add-to-cart-btn").prop("disabled", true);
      $("#sicky-add-to-cart-btn span").text("Sold Out");
    } else {
      $('.product-block-custom-html').removeClass('custom_sold-out-margin');
      $("#sicky-add-to-cart-btn").prop("disabled", false);
      $("#sicky-add-to-cart-btn span").text("Add To Cart");
    }
  });

  $(document).scroll(function () {
    var y = $(this).scrollTop();
    if (y > 550) {
      $("#product-atc-bar--mobile").fadeIn();
    } else {
      $("#product-atc-bar--mobile").fadeOut();
    }
  });

  $(document).on("click", ".variant__list--main", function () {
    $(".product-atc-bar__popup--material").toggleClass("activated");
  });

  $(document).on("click", ".size_selector--sticky", function (e) {
    $("#product-bar-buy-select-stone").removeClass("activated");
    $("#product-bar-buy-select-size").toggleClass("activated");
  });
  $(document).on("click", ".stone_selector--sticky", function (e) {
    $("#product-bar-buy-select-size").removeClass("activated");
    $("#product-bar-buy-select-stone").toggleClass("activated");
  });

  $(document).on("click", "#sicky-add-to-cart-btn", function () {
    if ($(this).is(":disabled")) {
      return;
    }
    $(this).addClass("btn--loading");

    setTimeout(function () {
      $("#sicky-add-to-cart-btn").removeClass("btn--loading");
    }, 2000);
    $(".addtoCartbutton").click();
  });

  // end of sticky add to cart button
});

$(document).ready(function () {
  if (window.location.href.indexOf("filter") > -1) {
    $(".grid__item.grid-product").each(function (i, obj) {
      var $this = $(this);
      var querystring = $(this)
        .find("a.grid-product__link")
        .prop("href")
        .split("?")[1];
      if (querystring != null) {
        var values = querystring.split("&");
      }
      // console.log(values);
      for (var key in values) {
        var obj = values[key];
        if (obj.indexOf("variant") != -1) {
          var index = values[key];
        }

        // ...
      }
      // console.log(index);
      function hasNumber(myString) {
        return /\d/.test(myString);
      }
      var variant_id = index;
      if (variant_id != null) {
        variant_id = variant_id.replace(/[^0-9\.]/g, "");
      }
      // var variantText = $(this).find('select option[value="' + variant_id + '"]').attr('variant-title');
      // variantText = variantText.replace(/[a-z]*\d+[a-z]*/gi, '');

      var activeSizeFilters = new Array();
      var activeStoneFilters = new Array();
      var combinedArr = new Array();

      $(".tag-list--active-tags .tag").each(function () {
        var tagText = $(this).find(".btn").text();
        if (hasNumber(tagText)) {
          tagText = tagText.replace(/\D/g, "");
          activeSizeFilters.push(tagText);
        } else {
          activeStoneFilters.push(tagText);
        }
      });

      function testString(testData, lookup) {
        return testData.toLowerCase().indexOf(lookup) === -1;
      }

      // console.log(variantText);
      var sizeAvailablity = $(this)
        .find('select option[value="' + variant_id + '"]')
        .attr("available");

      if (sizeAvailablity == "false") {
        if (activeSizeFilters !== undefined || activeSizeFilters.length != 0) {
          let variantAvailablity = "false";
          for (var i = 0; i < activeSizeFilters.length; i++) {
            try {
              $this.find("select option").each(function () {
                var string = $(this).attr("variant-title");
                if (string.includes(activeSizeFilters[i])) {
                  // console.log("string " + string )
                  // console.log("activeSizeFilters[i] " + activeSizeFilters[i] )
                  // console.log(this.text + ' ' + this.value);
                  variantAvailablity = $(this).attr("available");
                  if (variantAvailablity == "true") {
                    console.log("url-change");
                    $this
                      .find("a.grid-product__link")
                      .attr("href", $(this).attr("data-url"));
                    throw new Error("Break the loop.");
                  }
                }
              });
            } catch (error) {}
          }
          if (variantAvailablity == "false") {
            // $this.addClass('Naveed--hide');
            console.log("class-added");
            $this.remove();
          }
        }
      }

      let materialSwatchName = $(".filter_name_Material.tag--active")
        .find("input")
        .val();
      if (
        materialSwatchName != "undefine" &&
        materialSwatchName != null &&
        materialSwatchName !== ""
      ) {
        materialSwatchName = materialSwatchName
          .toLowerCase()
          .replace(/ /g, "-");

        materialSwatchName = "color-swatch--" + materialSwatchName;

        // console.log(materialSwatchName);

        $this
          .find("a." + materialSwatchName)
          .addClass("active")
          .trigger("click");
      }

    });
  }
});

(function ($) {
  $(document).ready(function () {
    $(".product__main-photos a").magnificPopup({
      gallery: {
        enabled: true,
      },
      type: "image",
      zoom: {
        enabled: true, // By default it's false, so don't forget to enable it

        duration: 300, // duration of the effect, in milliseconds
        easing: "ease-in-out", // CSS transition easing function

        // The "opener" function should return the element from which popup will be zoomed in
        // and to which popup will be scaled down
        // By defailt it looks for an image tag:
        opener: function (openerElement) {
          // openerElement is the element on which popup was initialized, in this case its <a> tag
          // you don't need to add "opener" option if this code matches your needs, it's defailt one.
          return openerElement.is("img")
            ? openerElement
            : openerElement.find("img");
        },
      },
    });
  });
})(jQuery);

$(document).ready(function () {
  $(".site-nav__link--icon-search img").click(function (e) {
    e.preventDefault();
    $("#epb_container").addClass("hide");
  });

  $("#SearchClose").click(function (e) {
    $("#epb_container").removeClass("hide");
  });

  // Prevent events from getting pass .popup
  $(".site-header__search-container").click(function (e) {
    e.stopPropagation();
  });

  $("#customSortBy-CollectionSidebar").change(function () {
    console.log("change");
    var val = $(this).val();
    $("#SortBy").val(val).change();
    let url = window.location.href;
    if (url.indexOf("?") > -1) {
      url = url.split("?")[0].split("#")[0];
      url += "?sort_by=" + val;
    } else {
      url = url.split("?")[0].split("#")[0];
      url += "?sort_by=" + val;
    }
    window.location.href = url;
  });
  if ($(window).width() > 780) {
    $(".grid__item.grid__item--sidebar").css("height", $(window).height());
  }

  $(".no-bullets.tag-list").each(function () {
    if ($(this).children().length == 0) {
      console.log("tur");
      $(this)
        .closest(".collapsible-content")
        .closest(".custom-filter-title")
        .hide();
    }
  });

});

$(document).ready(function () {

    if (window.matchMedia('(max-width: 767px)').matches) {
        $('.gem-encyclopedia-accordion.desktopp').remove();
    } else {
        $('.gem-encyclopedia-accordion.mobileee').remove();
    }
  
});

$(document).ready(function () {
  $(document).on("click", ".collapse-btn.collapsed", function (e) {
    
    e.preventDefault();
    $(".gem-callout-container").removeClass("show");
    let ModelId = $(this).attr("aria-controls");
    $("#" + ModelId).addClass("show");
     $('html, body').animate({
        scrollTop: $("#" + ModelId).offset().top -200
    }, 500);
    
  });

  $(document).on("click", ".close-accordion", function (e) {
     e.preventDefault();
    $(".gem-callout-container").removeClass("show");
  });

  var selectedstoneParent = $('input[name="Stone"]:checked').parent();

    var check = location.hash;
  
    check = check.replace('#', '');
   $('.collapse-btn.collapsed[main-stone="'+check+'"]').click(); 
  
});

$(document).ready(function () {
  $(".custom-cart-checkbox-input").change(function () {
    var isChecked = $(this).is(":checked");
    localStorage.setItem("checked", isChecked);
    if (isChecked) {
      if (!$("#CartDrawerForm").find("#CartNote").length) {
        let cart_Note = `<textarea name="note" id="CartNote">Yes, I want Sustainable Packaging</textarea>`;
        $("#CartDrawerForm").append(cart_Note);
        $("#CartPageForm").append(cart_Note);
      }
    } else {
      $("#CartDrawerForm").find("#CartNote").remove();
      $("#CartPageForm").find("#CartNote").remove();
    }
  });

  $(document).on("click", ".eco-packaging_terms", function (e) {
    e.preventDefault();
    $(".eco-packaging").fadeIn();
    $(".eco-packaging").addClass("active");
  });

  $(document).on("click", ".eco-packaging", function (e) {
    e.stopPropagation();
  });

  $(document).on("click", ".eco-packaging-close", function (e) {
    $(".eco-packaging").removeClass("active");
    $(".eco-packaging").fadeOut();
  });

  jQuery(function ($) {
    // localStorage saves text only
    var checked = localStorage.getItem("checked") === "true";

    $(".custom-cart-checkbox-input").prop("checked", checked);

    if ($(".custom-cart-checkbox-input").is(":checked")) {
      let cart_Note = `<textarea name="note" id="CartNote">Yes, I want Sustainable Packaging</textarea>`;
      $("#CartDrawerForm").append(cart_Note);
      $("#CartPageForm").append(cart_Note);
    }
  });

  $('.auto-click').click();
  
});
$(document).ready(function() {
  if (window.location.href.indexOf("product") > -1) {
            $('.tooltip').tooltipster({
                contentAsHTML: true,
                theme: 'tooltipster-custom-material',
                interactive: true,
                trigger: 'click'
            });
  }

      $(".position__sticky").scroll(function() {
        $('.tooltipstered').tooltipster('hide');
        console.log('hidee')
      });

if (window.location.href.indexOf("cart") > -1) {
    var shippingTime = '<div class="ships-today-container"><div class="trustblox-message">✓ Ships <span id="fulfilll">today</span> if ordered <span id="timee">05:41:39</span></div></div>';
    $(".shipment-container").prepend(shippingTime);

    if ($('.ships-today-container').length > 0) {
        console.log('running');

        var now = new Date();
        var weekday = now.getDay();
        var shipping_date = "today";
        var currentHour = now.getHours();
        var currentMinutes = now.getMinutes();
        var start = new Date(); // Start time for shipping cutoff

        // Set the cutoff time to 2 PM today
        var cutoffTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 14, 0, 0); // 2:00 PM

        // If it's after 2 PM, set shipping to tomorrow and start the countdown to 2 PM tomorrow
        if (now > cutoffTime) {
            shipping_date = "tomorrow";
            start.setDate(start.getDate() + 1); // Move to the next day
            start.setHours(14, 0, 0); // Set the cutoff to 2 PM tomorrow
        } else {
            // Before 2 PM, show countdown until 2 PM today
            shipping_date = "today";
            start.setHours(14, 0, 0); // Set the countdown to 2 PM today
        }

        // Handle weekends: If it's Friday, Saturday, or Sunday, set shipping to Monday
        if (weekday === 5 || weekday === 6 || weekday === 0) {
            shipping_date = "Monday";
            start.setDate(start.getDate() + (1 + (weekday === 0 ? 1 : 2))); // Move to next Monday
            start.setHours(14, 0, 0); // Set the cutoff to 2 PM Monday
        }

        function pad(num) {
            return ("0" + parseInt(num)).substr(-2);
        }

        function tick() {
            now = new Date();
            var remain = ((start - now) / 1000); // Calculate remaining time in seconds
            var hh = pad(Math.floor(remain / 60 / 60)); // Hours
            var mm = pad(Math.floor((remain / 60) % 60)); // Minutes
            var ss = pad(Math.floor(remain % 60)); // Seconds

            // Display the shipping date and countdown
            document.getElementById('fulfilll').innerHTML = shipping_date;
            if (remain > 0) {
                document.getElementById('timee').innerHTML = " within " + hh + " Hrs " + mm + " Mins " + ss + " Secs";
            } else {
                // If time is up, reset countdown for the next day's shipping
                if (shipping_date === "today") {
                    shipping_date = "tomorrow";
                    start.setDate(start.getDate() + 1);
                    start.setHours(14, 0, 0); // Countdown for 2 PM tomorrow
                    document.getElementById('fulfilll').innerHTML = shipping_date;
                } else {
                    shipping_date = "today";
                    start.setHours(14, 0, 0); // Reset to 2 PM of the new day
                    document.getElementById('fulfilll').innerHTML = shipping_date;
                }
            }

            // Keep ticking every second
            setTimeout(tick, 1000);
        }

        tick(); // Start the countdown
    }
}

});


$(document).ready(function() {
    $('.autoclick').click();
});

$(document).ready(function() {
    const variant = $('select.product-single__variants option:selected').attr('data-variant-title');
    if (variant) {
      
      const variantValues = variant.split('/').map(value => value.trim());

    const color = variantValues[0] || ''; 
    const size = variantValues[1] || '';  
    const stone = variantValues[2] || ''; 


    

// Function to handle the active class toggling
function toggleActiveClass(selector, variantValues) {
    $(selector).each(function() {
        // Check if the attribute 'variant-name' exists before accessing it
        let variantName = $(this).attr('variant-name');
        
        if (variantName) {
            variantName = variantName.trim();  // Only run trim if attribute is present
            if (variantValues.includes(variantName)) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        }
    });
}

// Check if the '#product-atc-material' element exists
if ($('#product-atc-material').length) {
    $('#product-atc-material').removeClass('active');
    toggleActiveClass('#product-atc-material .variant__item', [color, size, stone]);
}

// Check if there are no '.variant__item' inside '#product-atc-material', then check '#product-atc-bar--mobile'
if ($('#product-atc-material').find('.variant__item').length == 0 && $('#product-atc-bar--mobile').length) {
    toggleActiveClass('#product-atc-bar--mobile .variant__item', [color, size, stone]);
}

// Check for '.select-stone__item' if it exists
if ($('.select-stone__item').length) {
    toggleActiveClass('.select-stone__item', [color, size, stone]);
}

// Check for '.select-size__item' if it exists
if ($('.select-size__item').length) {
    toggleActiveClass('.select-size__item', [color, size, stone]);
}



      
    }
  });
